// @wf-will-never-add-flow-to-this-file

import {emotionStyled} from '@packages/utilities/styled';
import {Note} from '@packages/systems/spring';

/**
 * @deprecated Use Spring `Note` from `@packages/systems/spring` instead.
 * `BrandedNote` only adds a `padding: '$4'` override on top of the standard
 * `Note`. If you need the same padding, wrap `Note` with `emotionStyled`:
 *
 * ```tsx
 * const PaddedNoteView = emotionStyled(Note)({padding: '$4'});
 * ```
 */
export const BrandedNote = emotionStyled(Note)({
  padding: '$4',
});

BrandedNote.displayName = 'BrandedNote';

export default BrandedNote;
